<template>
<div class="pagebox" v-if="totalPage>1">
    <div class="yjui-page">
        <span class="yjui-page-count">共 {{totalCount}} 条</span>
        <!--上一页按钮事件 -->
        <a v-if="currentPage > 1" href="javascript:;" class="yjui-page-prev" @click="prev"><i class="yjui-icon icon-fanhui"></i></a>
        <!-- 第一页 -->
        <a v-if="slitm" href="javascript:;" @click="changePage(1)">1</a>
        <span v-if="slitm"  class="yjui-page-spr">…</span>
        <!-- 分页序号 -->
        <template v-for="(i, index) in grouplist"  >
            <span v-if="i == currentPage" class="yjui-page-curr"><em class="yjui-page-em"></em><em>{{i}}</em></span>
            <a v-else href="javascript:;" @click="changePage(i)">{{i}}</a>
        </template>
        <span v-if="elitm" class="yjui-page-spr">…</span>
        <!--最后一页 -->
        <a v-if="elitm" href="javascript:;"  @click="changePage(totalPage)">{{totalPage}}</a>
        <!-- 下一页按钮事件 -->
        <a v-if="currentPage != totalPage" @click="next" href="javascript:;" class="yjui-page-next"><i class="yjui-icon icon-fanhui"></i></a>
        <span class="yjui-page-limits" v-if="limits">
            <select id="yjui-page-select" v-model="currentPageSize" @change="changePage(1)">
                <option v-for="(item,idex) in pageSizeOpts" :value="item">{{item}} 条/页</option>
            </select>
        </span>
        <a href="javascript:;" v-if="refresh"  @click="changePage(currentPage)"  class="yjui-page-refresh"><i class="yjui-icon icon-shuaxin_1"></i></a>
        <span class="yjui-page-skip">到第<input type="text" name="pageskip" min="1"  v-model="jumpSize" >页<button type="button" @click="gotopage" class="yjui-page-btn">确定</button></span>
    </div>
</div>
</template>
<script>
 export default {
        name: 'Page',
         props: {
            current: {
                type: Number,
                default: 1
            },
            totalCount: {
                type: Number,
                default: 0
            },
            pageSize: {
                type: Number,
                default: 10
            },
            pageSizeOpts: {
                type: Array,
                default () {
                    return [10,15, 20, 30, 40, 50];
                }
            },
            limits: {
                type: Boolean,
                default: true
            },
            refresh: {
                type: Boolean,
                default: true
            }
         },
          data () {
            return {
                currentPage: this.current,
                currentPageSize: this.pageSize,
                jumpSize:this.current
            };
        },
        watch: {
            currentPageSize(val){//选择分页数
                this.currentPage=1;
                this.totalPage
            }
        },
         computed: {
            totalPage(){
                return  this.totalCount % this.currentPageSize == 0 ? this.totalCount /this.currentPageSize : Math.ceil(this.totalCount / this.currentPageSize);//总共多少页
            },
            slitm(){
                if (this.totalPage <= 5) return false;
                return this.currentPage >= 5

            },
            elitm(){
                if(this.currentPage  < 5 && this.totalPage > 5)
                {
                    return true
                }
                else if(this.currentPage >= 5 && this.currentPage <= this.totalPage - 4)
                {
                    return true
                }else{
                    return false;
                }
           
            },
            grouplist: function () { // 获取分页页码
                var pagelist=[];
                 if (this.totalPage <= 5) {
                    for (var i = 1; i <= this.totalPage; i++) {
                        pagelist.push(i);
                    }
                 }else{
                    if (this.currentPage < 5) {
                        for (var i = 1; i <= 5; i++) {
                            pagelist.push(i);
                        }
                    }
                    else if (this.currentPage > this.totalPage - 4) {
                        for (var i = this.totalPage - 4; i <= this.totalPage; i++) {
                            pagelist.push(i);
                        }
                    }
                    else if(this.currentPage  >= 5 && this.currentPage  <= this.totalPage - 4)
                    {
                        for (var i = this.currentPage - 2; i <= Number(this.currentPage) + Number(2); i++) {
                             pagelist.push(i);
                        }
                    }
                 }


                return pagelist;

            }

         },
          methods: {
            changePage (page) {
                this.currentPage=page;
                this.jumpSize=page;
                this.$emit('on-change', {page,pageSize:this.currentPageSize});
            },
            prev () {
                this.changePage(this.currentPage - 1);
            },
            next () {
               
                this.changePage(this.currentPage + 1);
            },
            gotopage(){
                if(this.jumpSize<1||this.jumpSize>this.totalPage)
                {
                     this.$Message.error("你已越界啦");
                    return
                }
      
                this.changePage(this.jumpSize);
            }
          }


 }

</script>
<style scoped>
    /*公共分页效果*/
    .pagebox { text-align: right }
    .yjui-page { display: inline-block; *display: inline; *zoom: 1; vertical-align: middle; margin: 10px 0; font-size: 0; }
    .yjui-page, .yjui-page * { box-sizing: content-box; }
    .yjui-page a, .yjui-page-curr, .yjui-page-spr, .yjui-page-limits select, .yjui-page-skip, .yjui-page button, .yjui-page input { border: 1px solid #e2e2e2; }
    .yjui-page a, .yjui-page span { display: inline-block; *display: inline; *zoom: 1; vertical-align: middle; padding: 0 15px; height: 28px; line-height: 28px; margin: 0 -1px 5px 0; background-color: #fff; color: #333; font-size: 14px; }
    .yjui-page .yjui-page-curr { position: relative; }
    .yjui-page .yjui-page-curr .yjui-page-em { position: absolute; left: -1px; top: -1px; padding: 1px; width: 100%; height: 100%; background-color: #009688; }
    .yjui-page .yjui-page-curr em { font-style: normal; position: relative; color: #fff; }
    .yjui-page select { height: 22px; padding: 3px; border-radius: 2px; cursor: pointer; outline: 0; }
    .yjui-page .yjui-page-count, .yjui-page .yjui-page-limits, .yjui-page .yjui-page-refresh, .yjui-page .yjui-page-skip { margin-left: 10px; margin-right: 10px; padding: 0; border: none; }
    .yjui-page .yjui-page-limits, .yjui-page .yjui-page-refresh { vertical-align: top }
    .yjui-page .yjui-page-skip { height: 30px; line-height: 30px; color: #999; }
    .yjui-page input { width: 40px; margin: 0 10px; padding: 0 3px; text-align: center; }
    .yjui-page button, .yjui-page input { height: 30px; line-height: 30px; border-radius: 2px; vertical-align: top; background-color: #fff; box-sizing: border-box; outline: 0; -webkit-appearance: none; }
    .yjui-page button { margin-left: 10px; padding: 0 10px; cursor: pointer; }
    .yjui-page .yjui-page-spr { color: #999; font-weight: 700; }
    .yjui-page .yjui-page-refresh { padding-top: 3px; }
    .yjui-page .yjui-page-refresh i { font-size: 18px; cursor: pointer; }
    .yjui-page .yjui-page-next { transform: rotateY(180deg); font-size: 18px }
    .yjui-page .yjui-page-prev { font-size: 18px }
</style>


// WEBPACK FOOTER //
// src/components/page/page.vue